module.exports = __webpack_public_path__ + "img/hit-customer-2.8eec6cc7.svg";